import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut as fbSignOut,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// cv-priorities web config — shared with deal-pipeline-crm.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

/** Allowed sign-ins — must match firestore.rules isClosingUser(). A bare domain
 *  admits the domain; an entry containing "@" admits that one address. */
export const ALLOWED_DOMAINS: string[] = (
  (import.meta.env.VITE_ALLOWED_EMAIL_DOMAINS as string | undefined) ??
  "chicagoventure.com,julian@julianfife.com"
)
  .split(",")
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

/** Denied even though their domain is allowed — no access to this tool; has
 *  Beacon only. Must match DENIED_EMAILS in the backend. */
export const DENIED_EMAILS: string[] = ["slynch@chicagoventure.com"];

export function isAllowedEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const lc = email.toLowerCase();
  if (DENIED_EMAILS.includes(lc)) return false;
  return ALLOWED_DOMAINS.some((d) => (d.includes("@") ? lc === d : lc.endsWith(`@${d}`)));
}

export async function signInWithGoogle(): Promise<void> {
  const provider = new GoogleAuthProvider();
  const hd = ALLOWED_DOMAINS.find((d) => d.includes("chicagoventure")) ?? ALLOWED_DOMAINS[0];
  provider.setCustomParameters({
    ...(hd ? { hd } : {}),
    prompt: "select_account",
  });
  await signInWithPopup(auth, provider);
}

export async function signOut(): Promise<void> {
  await fbSignOut(auth);
}
